import { Controller } from "@hotwired/stimulus"

// Generic reusable submenu controller for dropdown menus.
// Toggles a nested panel within a parent dropdown.
// Handles click-outside to auto-close and viewport-aware positioning.
//
// Usage:
//   <div data-controller="dropdown-submenu">
//     <button data-action="click->dropdown-submenu#toggle">Open</button>
//     <div data-dropdown-submenu-target="panel" style="display: none;">
//       ...submenu content...
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside)
  }

  toggle(event) {
    event.stopPropagation()

    const isVisible = this.panelTarget.style.display !== "none"

    if (isVisible) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.panelTarget.style.display = "block"
    this.positionPanel()

    setTimeout(() => {
      document.addEventListener("click", this.boundHandleClickOutside)
    }, 0)
  }

  close() {
    this.panelTarget.style.display = "none"
    document.removeEventListener("click", this.boundHandleClickOutside)
  }

  positionPanel() {
    const panel = this.panelTarget
    const rect = this.element.getBoundingClientRect()
    const panelWidth = panel.offsetWidth || 160
    const viewportWidth = window.innerWidth

    // Default: open to the right
    if (rect.right + panelWidth > viewportWidth) {
      // Not enough space on the right, open to the left
      panel.style.left = "auto"
      panel.style.right = "100%"
    } else {
      panel.style.left = "100%"
      panel.style.right = "auto"
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
